import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import {
  SelectDropdown,
  Props as SelectDropdownProps,
} from '../../Select/SelectDropdown';
import { getError } from '../utils';
import InputError from '../InputError';

type Props = Omit<SelectDropdownProps, 'value' | 'onChange'> & {
  name: string;
  onValueChange?: (val: string | null) => void;
};

export const SelectDropdownControlled: React.FC<Props> = ({
  name,
  onValueChange,
  ...props
}) => {
  const { control, errors } = useFormContext();

  const error = getError(name, errors);

  return (
    <>
      <Controller
        as={({ value, onChange }) => {
          return (
            <SelectDropdown
              {...props}
              className={[props.className, error ? 'is-invalid' : null]
                .filter((x) => !!x)
                .join(' ')}
              value={value}
              onChange={(value: string | null) => {
                onChange(value);
                onValueChange && onValueChange(value);
              }}
              error={error !== undefined}
            />
          );
        }}
        name={name}
        control={control}
      />
      <InputError error={error} />
    </>
  );
};
